import type { SearchScenarioId } from "owa-search-store";
import { action } from "satcheljs";

/**
 * Action that the consuming client should dispatch when it wants to change the
 * search text. The corresponding orchestrator will set the visible search text,
 * as well as the underlying text used to fetch suggestions and dispatch the
 * "getSuggestions" action so the client knows to fetch new suggestions.
 */
export interface ON_SEARCH_TEXT_CHANGEDActionMessage {
    searchText: string;
    scenarioId: SearchScenarioId;
}
export const onSearchTextChanged: (searchText: string, scenarioId: SearchScenarioId) => ON_SEARCH_TEXT_CHANGEDActionMessage = action("ON_SEARCH_TEXT_CHANGED", (searchText: string, scenarioId: SearchScenarioId): ON_SEARCH_TEXT_CHANGEDActionMessage => ({
    searchText,
    scenarioId,
}));
